import { OpeningHoursObject } from './lot.interface'

export interface Subscription {
    id: string
    lot_id: string
    start_date: string
    end_date: string
    subscription_status: SubscriptionStatus
    subscription_bookings: SubscriptionBooking[]
    lot_name: string
    lot_address: string
    lot_city: string
    payment_method: string
    subscription_price: string
    plates: string[]
    user_email: string
    created_at: string
    lot_opening_hours: OpeningHoursObject[]
}

interface Plate {
    plate: string
}

export enum SubscriptionStatus {
    ACTIVE = 'ACTIVE',
    COMPLETED = 'EXPIRED',
    CANCELLED = 'CANCELLED',
    FUTURE = 'PENDING'
}

export enum SubscriptionType {
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    NIGHTLY = 'NIGHTLY'
}

export interface SubscriptionBooking {
    start_date: string
    price: number
    plates: Plate[]
    payment_method: string
    lot_name: string
    lot_id: string
    lot_address: string
    end_date: string
    email: string
    created_at_iso_str: string
    invoices: {
        invoice_id: string
    }[]
    booking_ref: string
    booking_type: SubscriptionType
    night_parking_data: {
        iso_duration: string
        rrule: string
    }
}
